export default [
  {
    title: 'Nova versão da aplicação para clientes',
    date: 'Outubro 2022',
    read: '8min'
  }
];
